export default {"src":"/_next/static/media/icon-exclamation.d9576782.svg","height":54,"width":15,"blurWidth":0,"blurHeight":0};